//remember 
export const REMEMBER_USER = 'REMEMBER_USER';
//LOGIN 
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const LOGOUT_REQUEST = "LOGOUT_REQUEST";

export const CLEAR_RESPONSE_LOGIN ='CLEAR_RESPONSE_LOGIN';